import { Link, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import {
  BRANDED_CONTENT_POLICY_URL,
  MUSIC_USAGE_CONFIRMATION_URL,
} from './tiktok-disclosure-constants';
import { tiktokDisclosureMessages as messages } from './tiktok-disclosure-messages';

export interface TiktokDisclosureLegalTextProps {
  /** When true, shows branded content + music agreement; otherwise music only. */
  hasBrandedContent: boolean;
}

/**
 * Legal agreement text: branded content policy and/or music usage confirmation links.
 * Shown when disclosure is on; copy varies by whether user selected "Branded content".
 */
export function TiktokDisclosureLegalText({ hasBrandedContent }: TiktokDisclosureLegalTextProps) {
  return (
    <Typography variant="body2" color="text.secondary">
      {hasBrandedContent ? (
        <FormattedMessage
          {...messages.brandedContentAndMusicAgree}
          values={{
            brandedContentLink: (
              <Link href={BRANDED_CONTENT_POLICY_URL} target="_blank" rel="noopener noreferrer">
                <FormattedMessage {...messages.brandedContentPolicyLink} />
              </Link>
            ),
            musicLink: (
              <Link href={MUSIC_USAGE_CONFIRMATION_URL} target="_blank" rel="noopener noreferrer">
                <FormattedMessage {...messages.musicUsageConfirmationLink} />
              </Link>
            ),
          }}
        />
      ) : (
        <FormattedMessage
          {...messages.musicUsageAgree}
          values={{
            link: (
              <Link href={MUSIC_USAGE_CONFIRMATION_URL} target="_blank" rel="noopener noreferrer">
                <FormattedMessage {...messages.musicUsageConfirmationLink} />
              </Link>
            ),
          }}
        />
      )}
    </Typography>
  );
}
